/* eslint camelcase: 0 */ //
export default {
	sign_up_uri: `/auth/signup/company`,
	sign_in_uri: `/auth/signin`,
	forget_password_uri: `/auth/password-reset`,
	resend_confirmation_email_uri: `/auth/confirmation/resend`,
	activate_account_uri: `/auth/activate/:token`,
	verify_token_uri: `/auth/token/verify`,
	request_company_temp_access: `/auth/company/temp-access`,
	login_company_temp_access: `/auth/company/temp-access/login`,

	get_faq_questions: `/faq`,
	get_user_info: `/profile`,
	get_company_profile: `/company/profile`,
	update_user_profile: '/profile',
	update_company_profile: '/company/profile/:companyId',
	change_password: '/password/change',

	post_job: `/jobs`,
	clone_job: `/jobs/:jobId/clone`,
	edit_job: `/jobs/:jobId`,
	jobs: `/jobs`,
	set_job_status: '/job/:jobId/status',
	get_job_uri: `/jobs/:jobId`,
	jobs_summary: `/jobs/summary`,
	jobs_watched_summary: `/jobs/watched/summary`,
	watch_job: `/jobs/:jobId/watched`,
	unwatch_job: `/jobs/:jobId/watched`,
	make_offer: '/jobs/:jobId/applications/:applicationId/offers',
	accept_offer: '/jobs/:jobId/offers/:offerId/accept',
	update_offer_counter: '/jobs/offers',
	reject_offer: '/jobs/:jobId/offers/:offerId/reject',
	withdraw_offer: '/jobs/:jobId/offers/:offerId/withdraw',
	counter_offer: '/jobs/:jobId/offers/:offerId/counter',
	get_offers: '/jobs/offers',
	get_job_offers: '/jobs/:jobId/offers',
	remove_application_from_job: 'applications/:applicantId/withdrawApplication',
	get_candidate: '/candidate/:candidateId',
	get_candidates: '/candidates',
	get_candidate_applications: '/candidates/:candidateId/applications',
	get_candidate_CV: '/candidates/:candidateId/CV',
	create_candidate: '/candidates',
	update_candidate: '/candidate/:candidateId',
	delete_candidate_cv: '/candidate/:candidateId/cv/delete',
	delete_candidate_technical_report: '/candidate/:candidateId/technicalReport/delete',
	get_interview_slots: '/jobs/interview-slots',
	get_job_interview_slots: '/jobs/:jobId/interview-slots',
	assign_candidate_to_interview: '/jobs/:jobId/interview-slots/:slotId/assign',
	add_interview_permissions: '/company/:companyName/permissions/add',

	post_interview_slot_uri: '/jobs/:id/interview-slots',
	cancel_slot_uri: '/slots/:slotId/cancel',
	edit_interview_slot_uri: '/slots/:slotId/edit',
	companies_uri: '/companies',
	companies_summary_uri: '/companies/summary',
	get_company_uri: '/company/:companyId',
	get_company_contract_uri: '/company/:companyId/contract',
	delete_company_uri: '/company/:companyId/delete',
	get_current_company: '/company/profile',

	recommend_candidate: 'jobs/:jobId/applications',
	edit_permitted_interviews: '/company/:companyId/permissions/edit-permitted-interviews',
	edit_spent_interviews: '/company/:companyId/permissions/edit-spent-interviews',
	get_company_permissions_stat: '/company/permissions/stat',
	get_company_candidates: '/company/candidates/list',
	get_company_candidates_backoffice: '/company/:companyId/candidates/list',
	set_company_verification_state: '/company/:companyId/verified/',
	set_jobs_controlled_access: 'company/jobs-access',

	attach_report_to_application: 'job/:jobId/applications/:applicationId/add-report',
	job_application_edit: 'applications/:applicationId/edit',
	password_request_reset: '/password/request-reset',
	password_reset: '/password/reset',
	company_invite: '/auth/company/invite',
	add_custom_report_to_candidate: 'candidate/:candidateId/customTechnicalReport/add',
	delete_custom_report_to_candidate: 'candidate/:candidateId/customTechnicalReport/delete',

	get_interviews_packages: '/packages',
	purchase_package: '/packages/:packageId/purchase',
	get_package_order_invoices: '/package/orders',

	get_job_applications: '/jobs/:jobId/applications',
	change_application_state: 'jobs/applications/:applicationId/change-application-state',
	remove_applicant_label: '/jobs/:jobId/applications/:applicationId/label/:labelId',
	add_applicant_label: '/jobs/:jobId/applications/:applicationId/label/',
	get_applicant_comments: '/jobs/:jobId/applications/:applicationId/comments',
	comment_on_applicant: '/jobs/:jobId/applications/:applicationId/comments',
	upload_attachments: '/upload/attachments',
	delete_applicant_comment: '/jobs/:jobId/applications/:applicationId/comment/:commentId',
	edit_applicant_comment: '/jobs/:jobId/applications/:applicationId/comment/:commentId',
	set_emoji_comment: 'jobs/applications/comment/emoji',

	get_team_members: '/users/team-members',
	get_team_members_for_backoffice: '/users/team-members/:companyId',
	get_team_members_invitations: '/users/team-members/invitations',
	invite_team_members: '/users/team-members/invite',
	invitation_signup: '/users/team-members/invitation/signup',
	resend_team_member_invitation: '/users/team-members/invitation/:invitationId/resend',
	team_members_change_active_state: '/user/team-members/active-state/change',
	team_members_change_role: '/user/team-members/role/change',
	user_access_jobs: 'users/access-users/:userId',

	get_pending_applications: '/jobs/applications',
	set_developer_application_review_state: 'jobs/applications/:applicationId/set-state',

	matching_results_uri: '/dashboard/matching',
	get_matched_jobs: '/matching/jobs',
	get_matched_candidates: '/matching/candidates',

	get_company_comments: '/company/:companyId/comments',
	comment_on_company: '/company/:companyId/comments',
	delete_company_comment: '/company/comment/:commentId',
	edit_company_comment: '/company/comment/:commentId',

	perks_uri: '/perks',
	perk_request_uri: '/perks/:perkId/request',

	outsourcing_uri: '/outsourcing'
};
